<template>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar color-sidebar-teal" :class="!showSidebar ? 'collapse-sidebar' : ''">
   
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" :class="!showSidebar ? 'mini-sidebar' : ''">
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="nav-small-cap"> <span> Dashboard </span></li>
          <li> 
            <a href="#/tunjangan"> 
               <fa-icon class="md-size-1x mr-3" icon="home"></fa-icon>
              <span class="hide-menu"> Dashboard </span> 
            </a> 
          </li>
           <li> 
            <a href="#/tunjangan/tpp"> 
               <fa-icon class="md-size-1x mr-3 text-warning" icon="share-alt"></fa-icon>
              <span class="hide-menu">Laporan TPP</span> 
            </a> 
          </li>
           <li class="nav-small-cap"> <span>Data & Informasi  </span></li>
           <li> 
            <a href="#/prolap/statistikKinerja"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-bar"></fa-icon>
              <span class="hide-menu"> Mutasi Pegawai  </span> 
            </a> 
          </li>
           
           <li> 
            <a href="#/prolap/statistikProgram"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-line"></fa-icon>
              <span class="hide-menu"> Data Pensiun  </span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/statistikAnggaran"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-area"></fa-icon>
              <span class="hide-menu"> Data Kematian </span> 
            </a> 
          </li>

        </ul>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </aside>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState({
      showSidebar: state => state.showSidebar,
    //  menuItem: state => state.menuItem
    })
  },
  data() {
    return {
        menuItem : [] 
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapMutations({
     // toggleDropdown: "toggleDropdown"
    }),
     toggleDropdown(index) {
      this.menuItem[index].collapsed = !this.menuItem[index].collapsed;
    },
    fetchData() {

            this.$store.dispatch('getData',{
                url :  'api/site/apimenu?f=vue' 
            }) .then(response => {
                 this.menuItem  = response.data.data
            }).catch((error) => {
                alert(error)
            }) 

       
    }
  }
};
</script>

<style scoped>
.collapse-sidebar {
  width: 70px;
}
.collapse-sidebar #sidebarnav > li > a.has-arrow:after {
  display: none;
}
.svg-inline--fa {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Tunjangan.vue